import {
  CREATE_TRANSACTIONAL_METRICS_REQUEST, CREATING_TRANSACTIONAL_METRICS_SUCCEEDED, CREATING_TRANSACTIONAL_METRICS_FAILED
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const TRANSACTIONAL_METRICS_API_URL = `${apiUrl}/api/2.0/transactional_metrics`;

/**
* Create transactional metrics
*/
export const createTransactionalMetrics = createAction(CREATE_TRANSACTIONAL_METRICS_REQUEST, (request) => {
  return request;
})


const createTransactionalMetricsSucceeded = createAction(CREATING_TRANSACTIONAL_METRICS_SUCCEEDED, (response) => {
  return response;
})

const createTransactionalMetricsFailed = createAction(CREATING_TRANSACTIONAL_METRICS_FAILED, (error) => {
  return error;
})

function* createTransactionalMetricsSaga(action) {
  const request = action.payload;

  const createTransactionalMetricsAPI = () => {
    return axios.post(TRANSACTIONAL_METRICS_API_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createTransactionalMetricsAPI);
    if (response) {
      yield put(createTransactionalMetricsSucceeded(response));
    }
  } catch (error) {
    yield put(createTransactionalMetricsFailed(error));
  }
}

export default function* transactionalMetricsSaga() {
  yield takeEvery(CREATE_TRANSACTIONAL_METRICS_REQUEST, createTransactionalMetricsSaga);
}